import { render, staticRenderFns } from "./continutdigital.vue?vue&type=template&id=b0e0019e&scoped=true&"
import script from "./continutdigital.vue?vue&type=script&lang=js&"
export * from "./continutdigital.vue?vue&type=script&lang=js&"
import style0 from "./continutdigital.vue?vue&type=style&index=0&id=b0e0019e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e0019e",
  null
  
)

export default component.exports